// src/js/components/modals.js
if (!customElements.get("modal-dialog")) {
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, false));
      this.addEventListener("keyup", (event) => {
        if (event.code.toUpperCase() === "ESCAPE") this.hide();
      });
      if (this.classList.contains("media-modal")) {
        this.addEventListener("pointerup", (event) => {
          if (event.pointerType === "mouse" && !event.target.closest("deferred-media")) this.hide();
        });
      } else {
        this.addEventListener("click", (event) => {
          if (event.target === this) this.hide();
        });
      }
    }
    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }
    show(opener) {
      document.body.classList.add("has-active-modal");
      this.openedBy = opener;
      const popup = this.querySelector(".template-popup");
      document.body.classList.add("overflow-hidden");
      document.documentElement.classList.add("overflow-hidden");
      this.setAttribute("open", "");
      if (popup) popup.loadContent();
      trapFocus(this, this.querySelector('[role="dialog"]'));
    }
    hide() {
      document.body.classList.remove("has-active-modal");
      document.body.classList.remove("overflow-hidden");
      document.documentElement.classList.remove("overflow-hidden");
      document.body.dispatchEvent(new CustomEvent("modalClosed"));
      this.removeAttribute("open");
      removeTrapFocus(this.openedBy);
    }
  }
  customElements.define("modal-dialog", ModalDialog);
  window.ModalDialog = ModalDialog;
}
if (!customElements.get("modal-opener")) {
  class ModalOpener extends HTMLElement {
    constructor() {
      super();
      const button = this.querySelector("button");
      if (!button) return;
      button.addEventListener("click", () => {
        const modal = document.querySelector(this.getAttribute("data-modal"));
        if (modal) modal.show(button);
      });
    }
  }
  customElements.define("modal-opener", ModalOpener);
}
